/**
 * 기기 시간대 기준의 YYYY-MM-DD 문자열.
 *
 * `toISOString().slice(0, 10)` 을 쓰면 안 된다. 그쪽은 UTC 로 바꿔서 찍는데,
 * KST 자정은 UTC 로 전날 15:00 이다. 그래서 자정부터 오전 9시 사이에는 전날
 * 날짜가 나오고, 8월 10일 00:00 을 넘기면 "2026-08-09" 가 된다.
 *
 * 이 화면들은 전부 한국에서 쓰이고 날짜 표시도 기기 시간대 기준이라, 서버로
 * 보내는 날짜 문자열도 같은 기준이어야 앞뒤가 맞는다.
 */
export const toLocalDateString = (date = new Date()) => {
  const pad = (n) => String(n).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
};

export default toLocalDateString;
